// Calculo y estilos del "health" de un proyecto (a tiempo / en riesgo /
// atrasado / completado / continuo). Compartido entre Roadmap y Metricas
// para que el chip se vea igual en ambas vistas.

export const HEALTH_STYLES = {
  cyan:    'bg-cyan-50 text-cyan-700 border-cyan-200/70',
  emerald: 'bg-emerald-50 text-emerald-700 border-emerald-200/70',
  amber:   'bg-amber-50 text-amber-700 border-amber-200/70',
  rose:    'bg-rose-50 text-rose-700 border-rose-200/70',
  violet:  'bg-violet-50 text-violet-700 border-violet-200/70',
};

// Health a partir del snapshot del proyecto. El backend usa la misma logica.
// `p` necesita: es_continuo, rangoMin, rangoMax (Date), totalTareas, tareasHechas, progresoPct.
// Devuelve {key, label, color} o null si no hay datos suficientes.
export const calcularHealth = (p, today) => {
  if (p.es_continuo) return { key: 'continuo', label: 'Continuo', color: 'violet' };
  if (!p.rangoMin || !p.rangoMax) return null;
  if (p.totalTareas > 0 && p.tareasHechas === p.totalTareas) {
    return { key: 'completado', label: 'Completado', color: 'emerald' };
  }
  if (p.rangoMax < today) {
    return { key: 'atrasado', label: 'Atrasado', color: 'rose' };
  }
  const totalDias = Math.max(1, Math.round((p.rangoMax - p.rangoMin) / 86400000) + 1);
  const transcurridos = Math.max(0, Math.min(totalDias, Math.round((today - p.rangoMin) / 86400000)));
  const esperadoPct = (transcurridos / totalDias) * 100;
  if (p.progresoPct < esperadoPct - 15) {
    return { key: 'en_riesgo', label: 'En riesgo', color: 'amber' };
  }
  return { key: 'a_tiempo', label: 'A tiempo', color: 'cyan' };
};

// Chip compacto reutilizable. `health` puede venir directo del backend
// (con key/label/color) o calcularse en frontend con calcularHealth().
export const healthChipClass = (health) => {
  if (!health) return '';
  return HEALTH_STYLES[health.color] || HEALTH_STYLES.cyan;
};
